export const lockedState = {
  locked: "Locked",
  unlocked: "Unlocked"
};
